import { render, staticRenderFns } from "./ServiceTemplateManagement.html?vue&type=template&id=72afb703&scoped=true&external"
import script from "./ServiceTemplateManagement.js?vue&type=script&lang=js&external"
export * from "./ServiceTemplateManagement.js?vue&type=script&lang=js&external"
import style0 from "./ServiceTemplateManagement.scss?vue&type=style&index=0&id=72afb703&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afb703",
  null
  
)

export default component.exports